import './index.less';
import * as React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Scrollbar, Card, NoData } from '@beehive/components';
import { JournalTimeLine } from 'components';
import FlowNode from './FlowNode';
import moment from 'moment';
import { showAlert } from 'utils';
import projectDetailMessages from 'messages/Workbench/ProjectDetail';
import pageMessages from 'messages/Workbench/ProjectDetail/Progress';

const messages = { ...projectDetailMessages, ...pageMessages };

export interface ProgressProps {
  prefixCls?: string;
  getJournals: any;
  projectId: number;
  journals: any;
  showAlert?: any;
  hasRemindButton?: boolean;
}

export default class Progress extends React.Component<ProgressProps, any> {
  public static contextTypes = {
    intl: PropTypes.object,
  };

  public static defaultProps = {
    hasRemindButton: true,
  };

  public componentDidMount() {
    const { projectId } = this.props;
    this.getJournals(projectId);
  }

  public componentDidUpdate(prevProps: ProgressProps) {
    const { projectId } = this.props;
    if (projectId && projectId !== prevProps.projectId) {
      this.getJournals(projectId);
    }
  }

  public getJournals = (projectId: number) => {
    const { intl } = this.context;
    const { getJournals } = this.props;
    if (!projectId) {
      showAlert({ type: 'error', message: intl.formatMessage(messages.projectIdIllegal) });
      return;
    }
    getJournals({ id: projectId }).catch((error: any) => {
      showAlert({ type: 'error', message: typeof error === 'string' ? error : error.message });
    });
  }

  public render() {
    const { intl } = this.context;
    const {
      hasRemindButton,
      projectId,
      prefixCls,
      journals: { loading, journals = [], map_nodes = [], reminded_msg = {} },
    } = this.props;
    const classes = `${prefixCls}-progress`;
    const journalsNew = journals.slice().reverse();
    for (let i = 0; i < journalsNew.length - 1; i++) {
      if (journalsNew[i].created_at && journalsNew[i + 1].created_at) {
        journalsNew[i].interval = moment(journalsNew[i].created_at).diff(moment(journalsNew[i + 1].created_at));
      }
    }
    const classesHistory = classNames(`${prefixCls}-progress-update-history`, {
      [`${prefixCls}-progress-empty`]: !loading && !journalsNew.length,
    });

    const classesFlowNode = classNames(`${prefixCls}-progress-flow-node`, {
      [`${prefixCls}-progress-empty`]: !loading && !map_nodes.length,
    });

    return (
      <Scrollbar style={{ height: window.innerHeight - 120 }}>
        <div className={classes}>
          <Card
            titleNode={intl.formatMessage(messages['panelKeys.flowNode'])}
            loading={loading}
            className={classesFlowNode}
          >
            <Scrollbar autoHeight autoHeightMin={85} autoHeightMax={500}>
              {map_nodes.length ? (
                <FlowNode
                  mapNodes={map_nodes}
                  id={projectId}
                  remindState={reminded_msg}
                  hasRemindButton={hasRemindButton}
                />
              ) : (
                <div style={{ minHeight: 180, position: 'relative' }}>
                  <NoData type="empty" />
                </div>
              )}
            </Scrollbar>
          </Card>
          <Card
            titleNode={intl.formatMessage(messages['panelKeys.journals'])}
            loading={loading}
            className={classesHistory}
          >
            {journalsNew.length ? (
              <JournalTimeLine journals={journalsNew} />
            ) : (
              <div style={{ minHeight: 180, position: 'relative' }}>
                <NoData type="empty" />
              </div>
            )}
          </Card>
        </div>
      </Scrollbar>
    );
  }
}
